import CryptoJS from "crypto-js";

const generateStringA = (
  params,
  excludedKeys = ["sign", "agent", "extra"]
) => {
  const filteredParams = Object.keys(params)
    .filter(
      (key) => (params[key] || params[key] === 0) && !excludedKeys.includes(key)
    )
    .sort();
  let stringA = filteredParams.map((key) => `${key}=${encodeURIComponent(params[key])}`).join("&");
  return stringA;
};

const generateRandomString = (length) => {
  const characters =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  let result = "";
  const charactersLength = characters.length;
  for (let i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return result;
};

export const generateSign = (params) => {
  const stringA = generateStringA(params);
  const nonce = generateRandomString(32);
  const sign = CryptoJS.MD5(stringA + "&nonce=" + nonce)
    .toString()
    .toUpperCase();
  return {
    sign,
    nonce,
  };
};
